import styled from 'styled-components';
import { IsFetchingIndicator } from '../CommonComponents/IsFetchingIndicator/IsFetchingIndicator';

export const UserActivityHeader = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const UserActivityPageTitle = styled.h1`
  flex: 1;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #444;
`;

export const UserActivityDay = styled.div`
  margin: 40px 0;
`;

export const UserActivityDayTitle = styled.h2`
  font-weight: 600;
  font-size: 20px;
  color: #6C727F;
  margin: 0 0 24px;
`;

export const UserActivities = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;

  & + & {
    margin-top: 24px;
  }
`;

export const IsFetching = styled(IsFetchingIndicator)`
  position: absolute;
  bottom: -12px;
  left: 0;
`;
